import { getCore } from '../../../../client/core/getCore';
import { getDefaultClient } from '../../../../client/defaultClient';
import { createApiClient } from '../../../apiClient';
import type {
  CoinbaseOnrampGetBuyUrlRequest,
  CoinbaseOnrampGetBuyUrlResponse,
} from '../coinbase.types';

/**
 * Gets a Coinbase buy URL
 *
 * @param buyUrlParams CoinbaseOnrampGetBuyUrlRequest - The parameters for the buy URL.
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns an object containing the buy URL
 */
export const getCoinbaseBuyUrl = async (
  buyUrlParams: CoinbaseOnrampGetBuyUrlRequest,
  client = getDefaultClient()
): Promise<CoinbaseOnrampGetBuyUrlResponse> => {
  const core = getCore(client);
  const apiClient = createApiClient({ includeMfaToken: true }, client);

  const response = await apiClient.generateCoinbaseOnrampBuyUrl({
    coinbaseOnrampGetBuyUrlRequest: buyUrlParams,
    environmentId: core.environmentId,
  });

  return response;
};
